import React, { FunctionComponent, useState } from 'react';
import Translate from 'ui/atoms/translate';
import WithAuthenticatedPage from 'core/auth/components/with-authenticated-page';
import { AppType } from 'core/auth/types';
import WideContent from 'core/layout/content/wide-content';
import IssuerVouchersTable from './vouchers-table';
import VoucherModal from './create-voucher';
import Button from 'src/ui/atoms/button';
import { hasDistributionManageVouchersPermission } from '../../helpers/distributionPlatformPermissions';
import { useCurrentUserSelector } from 'src/core/auth/hooks';
import Spacer from 'src/ui/atoms/spacer';
import PageWrapper from 'src/core/layout/content/page-wrapper';

const IssuerVouchersPage: FunctionComponent = () => {
  const [forceDataLoad, setForceDataLoad] = useState(false);
  const [isCreateVoucherModalOpen, setCreateVoucherModalOpen] = useState(false);
  const [filterPopupHeight, setFilterPopupHeight] = useState(0);

  const { currentUser } = useCurrentUserSelector();

  const hasPermission = hasDistributionManageVouchersPermission(currentUser?.associatedDistributionPlatforms || []);

  const onVoucherCreated = () => {
    setForceDataLoad(true);
    setCreateVoucherModalOpen(false);
  };

  return (
    <PageWrapper paddingBottom={filterPopupHeight}>
      <WideContent
        title={<Translate name="dashboardIssuerVouchers.title" />}
        headerPanel={<VoucherModal onVoucherChanged={onVoucherCreated} isOpen={isCreateVoucherModalOpen} />}
        titleSpacing="larger"
      >
        {hasPermission && (
          <>
            <Button
              variant="primary"
              icon="plus"
              size="small"
              iconSize="small"
              iconColor="inherit"
              onClick={() => setCreateVoucherModalOpen(true)}
            >
              <Translate name="dashboardIssuerVouchers.create" />
            </Button>
            <Spacer y={4} />
          </>
        )}
        <IssuerVouchersTable
          defaultLimit={10}
          hasPermission={hasPermission}
          forceDataLoad={forceDataLoad}
          setForceDataLoad={setForceDataLoad}
          setFilterPopupHeight={setFilterPopupHeight}
        />
      </WideContent>
    </PageWrapper>
  );
};

export default WithAuthenticatedPage(IssuerVouchersPage, AppType.ISSUER);
